<nz-card [nzBordered]="true" nzType="inner" [nzSize]="'small'" nzTitle="Footer">
    <input nz-input placeholder="Type your template footer text here..." [(ngModel)]="messageBody" nzBorderless
        nzMaxTagCount="60" (keyup)="onKeyUp($event)" />
</nz-card>